// extracted by mini-css-extract-plugin
module.exports = {"container":"Comments_container__a6svF","comment":"Comments_comment__PmD1r","header":"Comments_header__1bAEw","textarea":"Comments_textarea__1DAuA"};